import http from '@monolith/legacy/services/api/http';
import { captureBrandsException } from '@core/plugins/sentry/helper';
import type { AxiosResponse } from 'axios';
import type { TieredDiscountsResponse, BrandSegmentsResponse } from '../types';

const jsonApiConfigs = {
  headers: {
    'Content-Type': 'application/vnd.api+json',
  },
};

export const getTieredDiscountsForRetailer = async (): Promise<TieredDiscountsResponse | null> => {
  try {
    const { data }: AxiosResponse<TieredDiscountsResponse> = await http().get(
      '/api/internal/v1/tiered-discounts/-actions/retailer',
      jsonApiConfigs
    );
    return data;
  } catch (error) {
    captureBrandsException(error, [
      { label: 'component', value: 'retailer-tiered-discounts/api' },
      { label: 'action', value: 'getTieredDiscountsForRetailer' },
    ]);
    return null;
  }
};

export async function fetchBrandSegmentsForRetailer(): Promise<BrandSegmentsResponse | null> {
  try {
    const { data } = await http().get<BrandSegmentsResponse>('/api/internal/v1/tiered-discounts/-actions/brand-segments');
    return data;
  } catch (error) {
    captureBrandsException(error, [
      { label: 'component', value: 'retailer-tiered-discounts/api' },
      { label: 'action', value: 'fetchBrandSegmentsForRetailer' },
    ]);
    return null;
  }
}
